import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';
import { gEnums } from 'global/enums/globalEnums';
import _ from 'lodash';
import { useContext, useState } from 'react';
import { Icon, Input, Label } from 'semantic-ui-react';
import { FilterContext } from '../cnr/contexts/FilterContext';
import { UiItemContext } from '../cnr/contexts/UiItemContext';
import { UIDictaphoneIcon } from './modification/dataModifications/UIDictaphone';

const WAIT_INTERVAL = 1500;

const UiSearchFilter = (props) => {

  const { handleSearchChange } = props

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem } = item_state ?? {}
  const { search } = viewItem ?? {}
  const { showVoiceSearch } = search ?? {}

  // filterContext
  const filterContext = useContext(FilterContext);
  const { uiFilter_handlers } = filterContext ?? {}

  // eslint-disable-next-line
  const [searchValue, setSearchValue] = useState('')

  const styleFns = useStyles()
  const tabsSnC = styleFns.setStyleAndClass({ item: gEnums.projectStyles.tabs })

  const handleCancel = () => {
    resetComponent(false)
    setSearchValue(' ')
    if (uiFilter_handlers) {
      uiFilter_handlers.handleSearchChange(null)
    } else if (handleSearchChange) {
      handleSearchChange(' ')
    }
  }

  const handleChange = (e, { value }) => {
    setSearchValue(value)
    setTimeout(() => {
      const _value = value.trim()
      if (_value.length < 1) return resetComponent()
      if (handleSearchChange) {
        handleSearchChange(_value)
      } else {
        if (uiFilter_handlers) {
          uiFilter_handlers.handleSearchChange(_value)
        } else if (handleSearchChange) {
          handleSearchChange(_value)
        }
      }
    }, WAIT_INTERVAL)
  }

  const handleResult = (value) => {
    setSearchValue(value)
    setTimeout(() => {
      if (value.length < 1) return resetComponent()
      if (handleSearchChange) {
        handleSearchChange(value)
      } else {
        if (uiFilter_handlers) {
          uiFilter_handlers.handleSearchChange(value)
        } else if (handleSearchChange) {
          handleSearchChange(value)
        }
      }
    }, WAIT_INTERVAL)
  }

  const resetComponent = (init) => {
    setSearchValue(' ')
    if (!init) {
      if (handleSearchChange) {
        handleSearchChange(' ')
      } else {
        if (uiFilter_handlers) {
          uiFilter_handlers.handleSearchChange(null)
        } else if (handleSearchChange) {
          handleSearchChange(' ')
        }
      }
    }
  }

  const searchLabel = () => {
    if (searchValue.length > 1) {
      return <Label onClick={handleCancel}><Icon name={'delete'} color={'red'} /></Label>
    } else {
      if (showVoiceSearch) {
        return <UIDictaphoneIcon handleResult={handleResult} oneTimeOnly={true} />
      } else {
        return <Label onClick={handleCancel}><Icon name={'delete'} color={'red'} /></Label>
      }
    }
  }

  const _style = { ...tabsSnC.style, margin: 0, padding: '.5em', width: '100%', backgroundColor: 'var(--off-black-4' }

  return <Input
    label={searchLabel()}
    labelPosition='left'
    icon={'search'}
    value={searchValue}
    onChange={_.debounce(handleChange, 500, { leading: true })}
    fluid
    style={_style}
  />
}

export default UiSearchFilter